<template>
  <a-modal
    title="新增用户"
    :visible="value"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
    :bodyStyle="{ paddingRight: '110px' }"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      layout="horizontal"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="昵称" prop="name">
            <a-input v-model="form.name" placeholder="请输入昵称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="账号" prop="username">
            <a-input v-model="form.username" placeholder="请输入账号" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="密码" prop="password">
            <a-input v-model="form.password" placeholder="请输入密码" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="角色" prop="role">
            <a-tree-select
              style="width: 100%"
              :treeData="roles"
              treeCheckable
              searchPlaceholder="选择角色!"
              v-model="form.role"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { getRoles, addUser } from '@/api/user-management'
import md5 from 'md5'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      confirmLoading: false,
      roles: [],
      form: {
        name: undefined,
        username: undefined,
        password: undefined,
        role: []
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入昵称',
            trigger: 'change'
          }
        ],
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }
        ],
        role: [
          {
            required: false,
            message: '请输入角色',
            trigger: 'change',
            type: 'array'
          }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getRoles().then(res => {
        if (res.code === 200) {
          const roles = res.result
          this.roles = roles.map(item => {
            item.key = item.id
            item.title = item.name
            item.value = item.id
            return item
          })
        }
      })
      // this.form.role = ['1']
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let { form } = this
          let values = {
            ...form,
            roleIds: form.role.join(','),
            password: md5(form.password)
          }
          this.confirmLoading = true
          addUser(values)
            .then(res => {
              if (res) {
                this.$notification['success']({
                  message: '成功',
                  description: `账号 ${form.name} 添加成功`
                })
                this.resetForm()
                this.$emit('input', false)
                this.$emit('success')
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped></style>
